import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';
import { STORY_AD_TYPES } from 'app/utils/constants';

const getStory = (id) => API.get(`/stories/${id}/`);

const getStoriesByIds = (ids = []) =>
  API.get(`/stories/?story_ids=${ids.join(',')}`);

const getStoryEpisodes = (
  storyId,
  ordering = 'newest',
  page = 1,
  perPage = 20
) => {
  const params = toParams({ page, perPage, ordering });
  return API.get(`/stories/${storyId}/episodes/?${params}`);
};

const getUserStories = (userId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${userId}/stories/?${params}`);
};

const getUserOtherStories = (userId, storyId, page = 1, perPage = 10) => {
  const params = toParams({ excludeId: storyId, page, perPage });
  return API.get(`/users/${userId}/stories/?${params}`);
};

const getEpisode = (storyId, episodeId) =>
  API.get(`/stories/${storyId}/episodes/${episodeId}/`);

const getStoryRecommendations = (
  storyId,
  lastEvaluatedKey = null,
  simsType,
  orderType = null
) => {
  const params = toParams({
    lastEvaluatedKey,
    storyIds: [storyId],
    simsType,
    ...(typeof orderType === 'string' && orderType.length > 0
      ? { orderType }
      : {}),
  });
  return API.get(`/v4/recommendation-stories/?${params}`);
};

const search = (q, page = 1, perPage = 20) => {
  const params = toParams({ q, page, perPage });
  return API.get(`/search/?${params}`);
};

// balloon
const purchaseByBalloon = (storyId, episodeId, type, voucherId) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/purchase-by-balloon/`, {
    type,
    ...(voucherId ? { voucherId } : {}),
  });

const readEpisode = (storyId, episodeId, data) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/read/`, data);

// choice
const getPaidChoices = (storyId, episodeId) =>
  API.get(`/stories/${storyId}/episodes/${episodeId}/purchase-paid-choices/`);

const purchaseChoice = (storyId, episodeId, balloon, choiceId) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/purchase-paid-choices/`, {
    balloon,
    choiceId,
  });

const previewByBalloon = (storyId, episodeId, balloon, message, voucherId) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/preview-by-balloon/`, {
    balloon,
    ...(message ? { message } : {}),
    ...(voucherId ? { voucherId } : {}),
  });

const bulkPurchaseByBalloon = (storyId, episodeIds, type) =>
  API.post(`/stories/${storyId}/episodes/bulk-purchase-by-balloon/`, {
    episodeIds,
    type,
  });

const getBulkPurchaseInfo = (storyId, episodeId, episodeCount, type) => {
  const params = toParams({ episodeId, episodeCount, type });
  return API.get(`/stories/${storyId}/episodes/bulk-purchase-info/?${params}`);
};

// ad
const getStoryAd = (type = STORY_AD_TYPES.FULL, storyId = null) => {
  const params = toParams({ type, storyId });
  return API.get(`/story-ads/?${params}`);
};

const clickStoryAd = (storyAdId, type = STORY_AD_TYPES.LIST) =>
  API.post(`/story-ads/${storyAdId}/click/?type=${type}`);

export default {
  getStory,
  getStoriesByIds,
  getStoryEpisodes,
  getUserStories,
  getUserOtherStories,
  getEpisode,
  getStoryRecommendations,
  search,
  purchaseByBalloon,
  readEpisode,
  getPaidChoices,
  purchaseChoice,
  previewByBalloon,
  bulkPurchaseByBalloon,
  getBulkPurchaseInfo,
  getStoryAd,
  clickStoryAd,
};



// WEBPACK FOOTER //
// ./src/app/apis/story.js